import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { RootState } from "../../store/reducers";
import { fetchArticles } from "../../store/actions";

import teamImage from "../../assets/career/career-1.png";
import meetImage from "../../assets/career/career-2.png";
import eventImage from "../../assets/career/career-3.png";
import developerImage from "../../assets/career/career-4.png";
import developerImage2 from "../../assets/career/career-5.png";
import team from "../../assets/career/team.png";
import OgCareer from "../../assets/OgCareer.png";

import LoaderOverlay from "../../components/LoaderOverlay";
import Container from "../../components/Container";
import Title from "../../components/Typography/Title";
import Description from "../../components/Typography/Description";
import VacancyItem from "../../components/Vacancy";
import Image from "../../components/Image";
import BackToTop from "../../components/BackToTop";
import Related from "../../components/Related";
import { Flex } from "../../utilities/GlobalStyle";
import { Helmet } from "react-helmet";
import { RAZZLE_APP_PORTAL_LINK } from "../../constants";

import { useAppSelector, useAppDispatch } from "../../hooks";

import * as S from "./style";

const Careers: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { items } = useAppSelector((state) => state.vacancies);
  const { articles } = useSelector((state: RootState) => state.articles.data);

  useEffect(() => {
    dispatch(fetchArticles(3));
  }, [dispatch]);
  console.log(RAZZLE_APP_PORTAL_LINK);
  return (
    <>
      <Helmet>
        <title>{`Unitiva - Careers`}</title>
        <meta
          property="og:url"
          content={
            typeof window !== "undefined"
              ? window.location.href
              : `${RAZZLE_APP_PORTAL_LINK}${location.pathname}`
          }
        />
        <meta property="og:title" content="Gioca in squadra con noi!" />
        <meta
          property="og:image"
          content={`${RAZZLE_APP_PORTAL_LINK}/theme_assets/images/OgCareer.png`}
        />
        <meta
          property="og:description"
          content="C’è sempre posto per chi sa mettersi in gioco. Consulta le posizioni aperte e scopri se hai tutti i requisiti per poter entrare a far parte del team."
        />
        <meta property="og:image:type" content="image/png" />
        <link
          rel="canonical"
          href={
            typeof window !== "undefined"
              ? window.location.href
              : `${RAZZLE_APP_PORTAL_LINK}${location.pathname}`
          }
        />
      </Helmet>
      <LoaderOverlay isWhite={true} />
      <S.FirstBackground />
      <S.SecondBackground />
      <Container>
        <S.CareersWrapper>
          <S.WelcomeText>
            <Title margin={[0, 0, 16]} title="Gioca in squadra con noi!" />
            <Description description="C’è sempre posto per chi sa mettersi in gioco." />
            <Description description="Consulta le posizioni aperte e scopri se hai tutti i requisiti per poter entrare a far parte del team." />
          </S.WelcomeText>
          {items.map(({ title, description, id }, i) => (
            <VacancyItem
              key={`${id}-${i}-vacancy`}
              id={id}
              title={title}
              description={description}
            />
          ))}
          <S.CondivisionGrid>
            <S.CondivisionGridItem>
              <S.CondivisionGridItemText textAlign="right">
                <Title size="3.2" title="Crediamo nella condivisione" />
                <p>
                  Crediamo nella forza delle <span>Community</span>, dell’
                  <span>apprendimento comune</span> e della{" "}
                  <span>condivisione</span>. Per questo partecipiamo o
                  organizziamo eventi, il nostro clima lavorativo è amichevole e
                  il nostro studio costante.
                </p>
              </S.CondivisionGridItemText>
            </S.CondivisionGridItem>
            <S.CondivisionGridItem>
              <S.CondivisionGridItemImage>
                <img src={teamImage} alt="team unitiva image" />
              </S.CondivisionGridItemImage>
            </S.CondivisionGridItem>
            <S.CondivisionGridItem padding={[0, 0, 0, 96]}>
              <S.CondivisionGridItemImage margin={[-32, 0]}>
                <img src={meetImage} alt="meeting image" />
              </S.CondivisionGridItemImage>
            </S.CondivisionGridItem>
            <S.CondivisionGridItem>
              <S.CondivisionGridItemImage>
                <img src={eventImage} alt="event image" />
              </S.CondivisionGridItemImage>
            </S.CondivisionGridItem>
            <S.CondivisionGridItem>
              <S.CondivisionGridItemImage margin={[-32, 0]}>
                <img src={developerImage} alt="developer unitiva image" />
              </S.CondivisionGridItemImage>
            </S.CondivisionGridItem>
            <S.CondivisionGridItem padding={[32, 0]}>
              <S.CondivisionGridItemText textAlign="left">
                <Title
                  size="3.2"
                  title="Conosciamo il valore del singolo e sappiamo come riconoscerlo"
                />
                <p>
                  Lasciamo spazio alle idee di ciascun membro del team, lo
                  incoraggiamo nell’inseguire sogni e{" "}
                  <span>realizzare i suoi progetti</span>, offrendogli il nostro
                  sostegno. Ci piace essere il segno del cambiamento!
                </p>
              </S.CondivisionGridItemText>
            </S.CondivisionGridItem>
          </S.CondivisionGrid>
          <S.Offer>
            <S.OfferWrapper>
              <S.ImageWrapperPseudoClass>
                <Image src={developerImage2} alt="developer unitiva image miglioramento continuo" />
              </S.ImageWrapperPseudoClass>
              <S.OfferWrapperText>
                <Title size="3.2" title="Offriamo miglioramento continuo" />
                <Description description="La nostra passione viene costantemente alimentata da studio, confronti tra colleghi, sessioni di codesign, briefing e progetti collettivi per testare nuove tecnologie. Se vuoi crescere questo è il posto giusto per te!" />
              </S.OfferWrapperText>
            </S.OfferWrapper>
          </S.Offer>
          <S.Candidature>
            <Flex
              alignItems="center"
              flexDirection="column"
              justifyContent="center">
              <S.ImageWrapper>
                <Image w="100%" h="100%" src={team} alt="team unitiva" />
              </S.ImageWrapper>
              <S.ImageOverlayBox
                alignItems="center"
                flexDirection="column"
                justifyContent="center">
                <S.ImageOverlayBoxContent>
                  <Title title="In Unitiva non ci si annoia mai!" size="3.2" />
                  <p>
                    Chi sceglie di entrare in questo mondo per{" "}
                    <span>passione</span> sa che oltre al lavoro c’è tanto{" "}
                    <span>divertimento!</span> I momenti di{" "}
                    <span>convivialità</span>, nonostante le distanze e le
                    circostanze, sono tanti e proficui, sia dal punto di vista{" "}
                    <span>professionale</span> che <span>umano</span>. Lasciati
                    coinvolgere!
                  </p>
                </S.ImageOverlayBoxContent>
              </S.ImageOverlayBox>
              <a className="send-candidature" href="mailto:jobs@unitiva.it">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28.001"
                  height="40"
                  viewBox="0 0 28.001 40">
                  <path
                    d="M410.414-2864.586l8.586-8.586V-2850a2,2,0,0,0,2,2,2,2,0,0,0,2-2v-23.172l8.586,8.586A2,2,0,0,0,433-2864a2,2,0,0,0,1.414-.586,2,2,0,0,0,0-2.828l-12-12a2,2,0,0,0-2.828,0l-12,12a2,2,0,0,0,0,2.828,2,2,0,0,0,2.828,0M435-2842a2,2,0,0,1-2,2H409a2,2,0,0,1-2-2,2,2,0,0,1,2-2h24a2,2,0,0,1,2,2"
                    transform="translate(-407 2880)"
                    fill="#fff"
                    fillRule="evenodd"
                  />
                </svg>
                Candidatura spontanea
              </a>
            </Flex>
          </S.Candidature>
          <S.OurWork>
            <Title
              title="Vuoi sapere a cosa stiamo lavorando di recente?"
              size="3.2"
            />
            <Description description="Anche se preferiamo il fare al raccontare, crediamo sia importante condividere esperienze che fanno crescere. Per questo alimentiamo il nostro Magazine con notizie di tecnologia, di innovazione e raccontiamo con orgoglio qualche storia di successo. Sei curioso? Dai una sbirciatina " />
          </S.OurWork>
        </S.CareersWrapper>
        <Related title="Ultime dal magazine" items={articles} />
        <BackToTop />
      </Container>
    </>
  );
};

export default Careers;
